import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import authRedux from '../redux/auth';
import coreRedux from '../redux/core';
import casesRedux from '../redux/cases';
import usersRedux from '../redux/users';
var sagaMiddleware = createSagaMiddleware();
var reducers = {
    auth: authRedux.reducer,
    core: coreRedux.reducer,
    cases: casesRedux.reducer,
    users: usersRedux.reducer,
};
var sagas = [authRedux.sagas, coreRedux.sagas, casesRedux.sagas, usersRedux.sagas];
export function makeStore() {
    return configureStore({
        reducer: reducers,
        middleware: [sagaMiddleware],
    });
}
var store = makeStore();
sagas.forEach(function (saga) { return sagaMiddleware.run(saga); });
export default store;
